const customerMember = () => import('@/views/main/customer/member/member.vue')
export default {
  path: '/main/customer/member',
  name: 'customerMember',
  component: customerMember,
  children: []
}
